import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './design/tokens.css';
import './design/reset.css';

import { App } from './App';
import { initApiClient } from './lib/api-client';
import { GIT_REV } from './buildInfo';

console.info('[dvvb build]', GIT_REV);

initApiClient();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
